import { Injectable } from '@angular/core';

import { AbcCoreComponent } from './abcCoreComponent';
import { AbcCoreComponentService } from './abcCoreComponent.service';

@Injectable()
export class AbcCoreContainerService {
  constructor(private abcCoreComponentService: AbcCoreComponentService) {}

  /**
   * Create ABC Component
   * @param ViewContainerRef: Represents a container where the view can be attached to the component.
   * @param component: The component you want to create.
   * @returns Instance of the created component.
   */
  createComponent<T>(ViewContainerRef, component: T): AbcCoreComponent {
    const loadedComponent: AbcCoreComponent = this.abcCoreComponentService.loadComponent(component, ViewContainerRef);
    return loadedComponent;
  }
}
